export enum Role {
  All = "all",
  Admin = "admin",
  Employee = "employee",
  Client = "client",
}
